/**
 * WLPermissionGuard — Bloqueia rota /wl quando o usuário não tem can_view
 * no menu indicado. Espelha o PermissionGuard do tenant.
 */
import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useWlPermissions } from '@/contexts/WlPermissionsContext';
import { createLogger } from '@/lib/logger';

const logger = createLogger('WLPermissionGuard');

interface Props {
  children: ReactNode;
  menuKey: string;
}

export function WLPermissionGuard({ children, menuKey }: Props) {
  const location = useLocation();
  const { loading, canView, isObserver, hasAccess } = useWlPermissions();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!hasAccess) {
    return <Navigate to="/access-denied" state={{ from: location.pathname }} replace />;
  }

  // Observador (root_admin) tem view universal — concedido via RPC
  if (!isObserver && !canView(menuKey)) {
    logger.warn('Acesso negado no /wl', { menuKey, route: location.pathname });
    return <Navigate to="/wl" state={{ denied: menuKey }} replace />;
  }

  return <>{children}</>;
}
